var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_6448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9068 80.0002L44.8812 63.1734L47.2192 62.0582L52.5536 73.2438L55.4344 65.1142L63.5616 67.9926L58.3464 57.0566L60.6844 55.9418L68.5908 72.5214L57.01 68.4198L52.9068 80.0002ZM27.0936 80.0002L22.9904 68.4198L11.4104 72.5214L19.3168 55.9418L21.6548 57.0566L16.4392 67.9926L24.5668 65.1142L27.448 73.2438L32.7824 62.0582L35.12 63.1734L27.0936 80.0002ZM40.0004 50.069C29.608 50.069 21.1536 41.6142 21.1536 31.2218C21.1536 20.8298 29.608 12.375 40.0004 12.375C50.392 12.375 58.8468 20.8294 58.8468 31.2218C58.8468 41.6142 50.392 50.069 40.0004 50.069ZM40.0004 14.9646C31.0368 14.9646 23.7432 22.2574 23.7432 31.2218C23.7432 40.1862 31.0368 47.4794 40.0004 47.4794C48.9648 47.4794 56.2572 40.1862 56.2572 31.2218C56.2572 22.2578 48.9648 14.9646 40.0004 14.9646Z",
    fill: "url(#paint0_linear_180_6448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6719 42.22L34.0703 34.0596L28.1423 28.2808L36.3359 27.09L40.0003 19.6636L43.6651 27.09L51.8599 28.2808L45.9311 34.06L47.3291 42.2196L40.0003 38.368L32.6719 42.22ZM40.0003 35.4424L43.8915 37.4868L43.1495 33.1548L46.2955 30.0884L41.9459 29.456L40.0011 25.5148L38.0559 29.456L33.7071 30.0884L36.8527 33.1552L36.1103 37.4864L40.0003 35.4424Z",
    fill: "url(#paint1_linear_180_6448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0035 62.484L34.4847 56.8516L27.1563 59.754L24.4063 52.3648L16.5287 52.0368L17.0227 44.1664L9.96154 40.6564L13.6143 33.6728L8.58594 27.5968L14.7671 22.6972L12.6443 15.106L20.2835 13.1436L21.4335 5.3404L29.2115 6.6592L33.4351 0L40.0031 4.3652L46.5651 0L50.7923 6.6596L58.5687 5.3408L59.7195 13.144L67.3571 15.1064L65.2363 22.6976L71.4135 27.5972L66.3891 33.6728L70.0431 40.6564L62.9803 44.1664L63.4747 52.0368L55.5935 52.3648L52.8463 59.754L45.5183 56.8516L40.0035 62.484ZM35.1299 53.81L40.0031 58.7828L44.8723 53.81L51.3411 56.3716L53.7663 49.8488L60.7247 49.5588L60.2883 42.6128L66.5231 39.5136L63.2975 33.3468L67.7339 27.9828L62.2791 23.6568L64.1519 16.9556L57.4095 15.2224L56.3931 8.3352L49.5291 9.5004L45.7967 3.6208L40.0039 7.4744L34.2051 3.6212L30.4759 9.5008L23.6095 8.3356L22.5947 15.2228L15.8507 16.956L17.7243 23.6572L12.2671 27.9832L16.7071 33.3472L13.4815 39.514L19.7147 42.6132L19.2791 49.5592L26.2339 49.8492L28.6615 56.3732L35.1299 53.81Z",
    fill: "url(#paint2_linear_180_6448)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6448",
    x1: 11.4107,
    y1: 46.1881,
    x2: 68.5908,
    y2: 46.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6448",
    x1: 28.1425,
    y1: 30.9419,
    x2: 51.8599,
    y2: 30.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6448",
    x1: 8.58625,
    y1: 31.2425,
    x2: 71.4135,
    y2: 31.2425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_6448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/Achievement.4c523373eb57f5865f773bb53d38d8d7.svg";
export { ForwardRef as ReactComponent };